import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Geometry from "@fae/source/utility/Geometry.js"
// import Random from "@fae/source/utility/Random.js"
// const random = new Random()

let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./LootPassiveModal.less"

function onClickDraft({stage, passive}) {
    return function(event) {
        if(passive == undefined) return

        // const unit = stage.units[passive.unitKey]
        // if(unit != undefined) {
        //     unit.passives.push(passive)
        // }

        stage.player.passives = stage.player.passives || []
        stage.player.passives.push(passive)

        if(passive.onDraft instanceof Function) {
            passive.onDraft()
        }

        CarryOn(stage)
    }
}

import PASSIVES from "@fae/source/data/games/ember/passives.jsx"
let RANDOMIZED_PASSIVES = undefined

export default function LootModal() {
    return [
        {
            "func": function(stage) {
                const chests = []

                if(RANDOMIZED_PASSIVES == undefined
                || RANDOMIZED_PASSIVES?.length == 0) {
                    // RANDOMIZED_PASSIVES = stage.random.shuffle(PASSIVES)
                    RANDOMIZED_PASSIVES = [...PASSIVES]
                }

                // const units = Object.values(stage.units).filter((unit) => {
                //     return unit.isDead != true
                //         && unit.isRecruited == true
                //         && unit.affiliation == stage.player.affiliation
                //         && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
                // })

                const passives = []
                passives.push(RANDOMIZED_PASSIVES.pop())
                passives.push(RANDOMIZED_PASSIVES.pop())
                passives.push(RANDOMIZED_PASSIVES.pop())
                // passives.push(RANDOMIZED_PASSIVES.pop())

                window.availablePassives = passives // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
            }
        },
        PlotSteps.CustomViewModal({
            "view": (stage) => {
                if(App?.game == undefined) return

                const passives = window.availablePassives // TODO AAAAAH IT IS 3:33AM BEFORE THE 7DRL DEADLINE PLEASE FORGIVE ME
                return (
                    <div class="LootModal">
                        <div class="Header">
                            <div class="BigText">Choose an Artifact</div>
                        </div>
                        <section class="LootablePassiveSection">
                            {Object.values(passives).map((passive, index) => {
                                if(passive == undefined) return
                                const unit = stage.units[passive.unitKey]
                                return (
                                    <div class="LootablePassive">
                                        <div class="Summary" onClick={onClickDraft({stage, passive})}>
                                            <div class="Title">{passive.title}</div>
                                            <div class="Description">{passive.description instanceof Function ? passive.description({stage, unit, passive}) : passive.description}</div>
                                        </div>
                                        <div class="Unit">
                                            <UnitSprite unit={unit}/>
                                        </div>
                                    </div>
                                )
                            })}
                        </section>
                    </div>
                )
            }
        })
    ]
}
